import ActionTypes from '../constants/action-types';
import standardAction from '../../../utilities/standard-action';
import { RootActionTypes } from '../../../stores/types';

export default function setNotification(message: string): RootActionTypes {
  return standardAction(ActionTypes.SET_NOTIFICATION, message);
}
